import React, { useEffect, useRef } from 'react'
import clsx from 'clsx';
import {
    Grid,
    Typography,
    Avatar,
    Paper
} from '@mui/material'
import customStyles from "../../../../assets/styles/customStyles";
import logoImg from "../../../../assets/images/logo.png";
import registerImg from "../../../../assets/images/register.png";
import { Image } from "antd";
import { useSelector } from "react-redux";
import { Link } from "react-router-dom"
import animation from "../../../../assets/images/TickMark.json";
import lottie from 'lottie-web'

const RegisterSuccess = (props) => {
    const { registerDetails } = useSelector(state => state.authReducer);
    //const { history } = props;
    const animationContainer = useRef(null);

    useEffect(() => {
        if (registerDetails === '') {
            //history.push("/register");
        }

        lottie.loadAnimation({
            container: animationContainer.current, // the dom element
            renderer: 'svg',
            loop: false,
            autoplay: true,
            animationData: animation
        });

    }, [registerDetails]);


    const classes = customStyles();
    return (
        <div className={clsx(classes.backgroundWhite, classes.boxBorder1)}>
            <Paper className={clsx(classes.authContainer)} sx={{ p: 2 }}>
                <Grid container className={clsx(classes.authRoot, classes.fullHei, classes.regSuccess)}>
                    <Link to="/login" className={clsx(classes.customLogoLink)}>
                        <Avatar alt="Logo" src={logoImg} className={clsx(classes.customLogo)} variant={'square'} />
                    </Link>
                    <Grid xxl={7} xl={7} lg={7} md={7} sm={5} item className={classes.mobileDisplay}>
                        <Image
                            alt="Login"
                            preview={false}
                            src={registerImg}
                            variant={'square'}
                        />
                    </Grid>
                    <Grid xxl={5} xl={5} lg={5} md={5} sm={7} xs={12} className={clsx(classes.cardSize, classes.loginForm)} item>
                        <Paper className={clsx(classes.cardSize, classes.loginForm)} style={{ backgroundColor: 'transparent' }}>
                            <Grid align='center'>
                                <div ref={animationContainer} style={{ width: '35%', height: 'auto' }}></div>
                                <Typography variant="h6" className={clsx(classes.margin15t, classes.fonSize14)}>
                                    Hello <span className={clsx(classes.bold)}>{registerDetails.name}</span>
                                </Typography>
                                <Typography variant="h6" className={clsx(classes.margin20t, classes.fonSize14)}>
                                    Your account has been created successfully. <br />
                                    Use the temporary password sent to your email to login to the application
                                </Typography>
                                <Link
                                    to={'/login'}
                                    className={clsx(classes.modalBtn, classes.margin40t)}
                                    fullWidth
                                    variant={'contained'}
                                >
                                    Login
                                </Link>
                            </Grid>
                        </Paper>
                    </Grid>
                </Grid>
            </Paper>
        </div>
    )
}

export default RegisterSuccess